/**
 * Translations that are not loaded from translations service.
 * Mostly for local development in case of new translations that are not yet in the translations service.
 * @type {{de: {}, en: {}, fr: {}}}
 */
export const defaultTranslation = {
  de: {},
  en: {},
  fr: {},
};
